<template>
  <div
    :class="`modal fade px-0 ${$props.value ? 'show d-block' : 'd-none'}`"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Send Email Test
          </h5>
          <button
            type="button"
            class="close"
            @click="close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body container-fluid text-center">
          <div class="row">
            <div
              data-field-email=""
              class="col-12 mb-2"
            >
              <input
                type="email"
                class="form-control"
                v-model="email"
                placeholder="someone@thinkspain.com"
              >
            </div>
            <div class="col-6">
              <select
                class="custom-select form-control"
                v-model="language"
              >
                <option value="no">
                  Norwegian
                </option> <option value="en">
                  English
                </option> <option value="es">
                  Spanish
                </option> <option value="de">
                  Deutsch
                </option> <option value="it">
                  Italian
                </option> <option value="fr">
                  French
                </option> <option value="pl">
                  Polish
                </option> <option value="nl">
                  Dutch
                </option> <option value="sv">
                  Swedish
                </option> <option value="da">
                  Danish
                </option> <option value="fi">
                  Finnish
                </option> <option value="pt">
                  Portuguese
                </option> <option value="ry">
                  Russian
                </option>
              </select>
            </div>
            <div class="col-6">
              <select
                class="custom-select form-control"
                v-model="currency"
              >
                <option value="EUR">
                  Euro
                </option>
                <option value="USD">
                  US Dollar
                </option>
                <option value="GBP">
                  British Pounds
                </option>
              </select>
            </div>
            <div class="col-12">
              <p class="mt-2 mb-2">Provinces</p>
              <ul class="in-cboxtags m-0 p-0">
                <li
                  v-for="province in provinces"
                  :key="province.Id"
                >
                  <input
                    type="checkbox"
                    v-model="selectedProvinces"
                    name="selectedProvinces"
                    :id="'checkboxProvince' + province.Id"
                    :value="province.Id"
                    @change="onProvinceSelect"
                  >
                  <label :for="'checkboxProvince' + province.Id">{{ province.Name }}</label>
                </li>
              </ul>
            </div>
            <div class="col-12">
              <p class="mt-2 mb-2">Regions</p>
              <ul class="in-cboxtags p-0">
                <li
                  v-for="region in regions"
                  :key="region.Id"
                >
                  <input
                    type="checkbox"
                    v-model="selectedRegions"
                    name="selectedRegions"
                    :id="'checkboxRegion' + region.Id"
                    :value="region.Id"
                    @change="onRegionSelect"
                  >
                  <label :for="'checkboxRegion' + region.Id">{{ region.Name }}</label>
                </li>
              </ul>
            </div>
            <div
              data-field-button=""
              class="col-12"
            >
              <button
                class="btn btn-primary btn-block mt-2"
                @click="send"
              >
                Send Test
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data: () => ( {
        email: localStorage.getItem( 'useremail' ),
        language: 'en',
        currency: 'EUR',
        provinces: [
            { Id: 0, Name: 'Not specified' },
            { Id: 1, Name: 'A Coruña' },
            { Id: 3, Name: 'Álava' },
            { Id: 4, Name: 'Albacete' },
            { Id: 2, Name: 'Alicante' },
            { Id: 5, Name: 'Almería' },
            { Id: 37, Name: 'Asturias' },
            { Id: 6, Name: 'Avila' },
            { Id: 7, Name: 'Badajoz' },
            { Id: 9, Name: 'Barcelona' },
            { Id: 10, Name: 'Burgos' },
            { Id: 12, Name: 'Cáceres' },
            { Id: 13, Name: 'Cádiz' },
            { Id: 14, Name: 'Cantabria' },
            { Id: 15, Name: 'Castellón' },
            { Id: 11, Name: 'Ciudad Real' },
            { Id: 17, Name: 'Córdoba' },
            { Id: 18, Name: 'Cuenca' },
            { Id: 63, Name: 'El Hierro' },
            { Id: 56, Name: 'Formentera' },
            { Id: 61, Name: 'Fuerteventura' },
            { Id: 19, Name: 'Girona' },
            { Id: 59, Name: 'Gran Canaria' },
            { Id: 20, Name: 'Granada' },
            { Id: 21, Name: 'Guadalajara' },
            { Id: 22, Name: 'Guipúzcoa' },
            { Id: 23, Name: 'Huelva' },
            { Id: 24, Name: 'Huesca' },
            { Id: 55, Name: 'Ibiza' },
            { Id: 25, Name: 'Jaén' },
            { Id: 62, Name: 'La Gomera' },
            { Id: 58, Name: 'La Palma' },
            { Id: 26, Name: 'La Rioja' },
            { Id: 60, Name: 'Lanzarote' },
            { Id: 28, Name: 'León' },
            { Id: 29, Name: 'Lleida' },
            { Id: 30, Name: 'Lugo' },
            { Id: 31, Name: 'Madrid' },
            { Id: 32, Name: 'Málaga' },
            { Id: 54, Name: 'Mallorca' },
            { Id: 53, Name: 'Menorca' },
            { Id: 34, Name: 'Murcia' },
            { Id: 35, Name: 'Navarra' },
            { Id: 36, Name: 'Orense' },
            { Id: 38, Name: 'Palencia' },
            { Id: 39, Name: 'Pontevedra' },
            { Id: 41, Name: 'Salamanca' },
            { Id: 42, Name: 'Segovia' },
            { Id: 43, Name: 'Sevilla' },
            { Id: 44, Name: 'Soria' },
            { Id: 45, Name: 'Tarragona' },
            { Id: 40, Name: 'Tenerife' },
            { Id: 46, Name: 'Teruel' },
            { Id: 47, Name: 'Toledo' },
            { Id: 48, Name: 'Valencia' },
            { Id: 49, Name: 'Valladolid' },
            { Id: 50, Name: 'Vizcaya' },
            { Id: 51, Name: 'Zamora' },
            { Id: 52, Name: 'Zaragoza' }
        ],
        regions: [
            { Id: 6, Name: 'Canary Islands' },
            { Id: 4, Name: 'Balearic Islands' }
        ],
        selectedRegions: [],
        selectedProvinces: []
    } ),
    methods: {
        close() {
            this.$emit( 'input', false );
        },
        send() {
            this.$emit( 'send', {
                email: this.email,
                language: this.language,
                currency: this.currency,
                provinces: this.selectedProvinces,
                regions: this.selectedRegions
            } );
        },
        onRegionSelect() {
            this.selectedProvinces = [];
        },
        onProvinceSelect() {
            this.selectedRegions = [];
        }
    },
    props: {
        value: {
            type: Boolean,
            required: true,
            default: () => false
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/templates/EmailTestModal.vue